import _uniq from 'lodash.uniq';
import _omitBy from 'lodash.omitby';
import _isUndefined from 'lodash.isundefined';

const ADDONS_WITH_MULTIPLE_VALUES = [
'SRT_CAPTIONS',
'SUPERSIZE_MY_EDIT',
'STOCK_ASSETS',
'VOICE_OVER_ARTISTS'];


export const formatAddons = (addons) =>
Object.keys(addons).reduce((newAddons, key) => {
  const addonObject = addons[key];

  if (!addonObject || key === '__typename') {return newAddons;}

  if (ADDONS_WITH_MULTIPLE_VALUES.includes(key) && Array.isArray(addonObject)) {
    // $FlowFixMe
    const items = addonObject.
    filter((srt) => srt.value).
    map(({
      // $FlowFixMe
      value, cost, description, addonId, createdAt, artistId, name, duration
    }) => _omitBy({
      // $FlowFixMe
      value, cost, description, addonId, createdAt, artistId, name, duration
    }, _isUndefined));

    return {
      ...newAddons,
      [key]: _uniq(items)
    };
  }

  if (addonObject.value === void 0 || addonObject.value === null) {
    return newAddons;
  }

  // $FlowFixMe - handled above
  const { cost, createdAt, value } = addonObject;
  const newAddonObject = { value, cost, createdAt };

  return {
    ...newAddons,
    [key]: addonObject.status
    // $FlowFixMe
    ? { ...newAddonObject, status: addonObject.status }
    // $FlowFixMe
    : newAddonObject
  };
}, {});